import React from "react";
import { Link } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import CssBaseline from "@material-ui/core/CssBaseline";
import { states } from "components/State&Subject/";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import Container from "@material-ui/core/Container";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import "./index.scss";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export default function Personal() {
  const classes = useStyles();
  const [age, setAge] = React.useState("");

  const handleChange = event => {
    console.log(setAge(event.target.value));
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid item xs={12} className={classes.mBottom}>
            <Typography>BIRTH INFORMATIONS</Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="surName"
                label="Surname"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="bname"
                label="Baptism Name"
                name="bname"
                autoComplete="bname"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="other"
                label="Other Names"
                name="other"
                autoComplete="other"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                defaultValue="1990-01-01"
                name="dob"
                label="Date of Birth"
                type="date"
                id="dob"
                autoComplete="dob"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="pob"
                label="Place of Birth"
                type="text"
                id="pob"
                autoComplete="pob"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="lga"
                label="L. G. A"
                type="text"
                id="lga"
                autoComplete="local-government"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="">State</InputLabel>
                <Select
                  fullWidth
                  labelId="state"
                  id=""
                  value={age}
                  onChange={handleChange}
                  label="Age"
                >
                  {states.map((state, i) => (
                    <MenuItem value={state.name} key={i}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                defaultValue="1990-01-01"
                name="dobath"
                label="Date of Baptism"
                type="date"
                id="dobath"
                autoComplete="date-of-baptism"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                defaultValue="1990-01-01"
                name="docoonf"
                label="Date of Confirmation"
                type="date"
                id="doconf"
                autoComplete="date-of-confirmation"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.mTop}>
              <Typography>HOMETOWN INFORMATIONS</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="noh"
                label="Name of Hometown"
                type="text"
                id="noh"
                autoComplete="hometown"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="ethinc"
                label="Ethnic Group and Language"
                type="text"
                id="ethnic"
                autoComplete="Ethnic"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="pos-adress"
                label="Postal Address"
                type="text"
                id="pos-address"
                autoComplete="postal address"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="h-email"
                label="Email Address"
                type="email"
                id="h-email"
                autoComplete="email-address"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="h-telephone"
                label="Telephone"
                type="phone"
                id="h-telephone"
                autoComplete="h-telephone"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="h-telephone"
                label="Enter Password"
                type="password"
                id="h-telephone"
                autoComplete="h-telephone"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="h-telephone"
                label="Confirm Password"
                type="password"
                id="h-telephone"
                autoComplete="h-telephone"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="dashboard"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="academic-information"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
